export const incidentTrendChart = (data = []) => {
  const periods = data.map(d => d.period);

  const severities = [
    { key: 'sev1', label: 'Sev 1', color: '#f5222d' },
    { key: 'sev2', label: 'Sev 2', color: '#fa541c' },
    { key: 'sev3', label: 'Sev 3', color: '#faad14' },
    { key: 'sev4', label: 'Sev 4', color: '#bfbfbf' }
  ];

  const series = severities.map(sev => ({
    name: sev.label,
    type: 'bar',
    stack: 'incidents',
    data: data.map(d => d[sev.key] ?? 0),
    itemStyle: {
      color: sev.color,
      borderRadius: sev.key === 'sev4' ? [4, 4, 0, 0] : 0
    }
  }));

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' }
    },
    legend: {
      data: severities.map(s => s.label),
      bottom: 0
    },
    grid: {
      left: '3%',
      right: '3%',
      top: '10%',
      bottom: '12%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: periods,
      axisLabel: { fontSize: 10 }
    },
    yAxis: {
      type: 'value',
      name: 'Incidents',
      minInterval: 1,
      axisLabel: { fontSize: 10 }
    },
    series
  };
};
